import { Loader } from "@fanduel/og-fe-library";
import { useMemo } from "react";
import ArticleComponent from "@/components/article/ArticleComponent";
import ErrorBoundary from "@/components/empty/ErrorBoundary";
import { Article } from "@/graphql/gql/graphql";
import useRouterLoading from "@/utils/hooks/useRouterLoading";
import styles from "./articlePreviewContainer.module.scss";

type ArticlePreviewContainerProps = {
  article: Article;
};

const ArticlePreviewContainer = ({ article }: ArticlePreviewContainerProps) => {
  const { loading } = useRouterLoading();

  const parsedArticle = useMemo(
    () => ({
      ...article,
      parsedBody: JSON.parse(article.body),
    }),
    [article]
  );

  return (
    <ErrorBoundary>
      <div className={styles.previewContainer}>
        {loading ? (
          <Loader data-testId="loader" size="medium" />
        ) : (
          <ArticleComponent article={parsedArticle} notify={() => {}} />
        )}
      </div>
    </ErrorBoundary>
  );
};

export default ArticlePreviewContainer;
